import { updateCart } from "../cart";

/**
 * Middleware to intercept cart update actions and inject bundle data from the store
 */
export const bundleMiddleware = store => next => action => {
  if (action.type === updateCart.type) {
    const state = store.getState();

    if (state.bundles && state.bundles.availableBundles) {
      const availableBundles = state.bundles.availableBundles || [];

      const enhancedAction = {
        ...action,
        payload: {
          ...action.payload,
          availableBundles
        }
      };

      return next(enhancedAction);
    }
  }

  return next(action);
};

export default bundleMiddleware;
